// extracted by mini-css-extract-plugin
export var dropdownButton = "_19-0";
export var fullWidthDropdownButton = "_19-1";
export var icon = "_19-3";
export var iconPlaceholder = "_19-2";
export var shortcutContainer = "_19-4";